export const isValidValueRegex = (regexValue, inputValue) => {
    const regex = new RegExp(regexValue, 'gi');
    return regex.test(inputValue);
}
export const autoCompleteOff = (id) => {
    $("#" + id).attr("autocomplete", "new-" + id);
}
export const formattedDate = (value) => {
    const date = new Date(value);
    return date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear() + ' à ' + date.getHours() + 'h' + date.getMinutes();
}
export const addressAutocomplete =   (address) => {
    var self = this;
    $('#' + address.zipCode.includingFormId).dqe({
        zip: '#' + address.zipCode.id,
        compl: '#' + address.compl.id,
        zipcity: '#' + address.zipCode.id,
        city: '#' + address.city.id,
        street: '#' + address.street.id,
        hasTwoAddresses: address.hasTwoAddresses,
        shippingCity: '#' + address.shippingCity.id,
        shippingZipCode: '#' + address.shippingZipCode.id,
        shippingStreet: '#' + address.shippingStreet.id,
        cedex: false,
        autocompleteInternalFunction: function () {
            fetchInseeCodeByZipCodeAndCity(address.zipCode.id, address.city.id, 'zipCode');
            self.zipCodeAndCityAutocompleteWithInternalApi(address.city.id, address.zipCode.id, 'city');

        }
    });
    $("#" + address.zipCode.id).attr("autocomplete", "new-zipCode");
    $("#" + address.city.id).attr("autocomplete", "new-city");
}

export const prepareDataForRequest = (data) => {
    const customerData = new URLSearchParams();
    customerData.append('view', 'full');
    customerData.append('context', 'newCustomerSpace');
    customerData.append('profile[email]', data.email);
    customerData.append('profile[firstname]', data.firstname);
    customerData.append('profile[lastname]', data.lastname);
    customerData.append('profile[civility]', data.civility);
    customerData.append('billingAddress[streetAddress]', data.billingAddress['streetAddress'] ? data.billingAddress['streetAddress'] : '');
    customerData.append('billingAddress[streetAddressComplement]', data.billingAddress['streetAddressComplement']);
    customerData.append('billingAddress[zipCode]', data.billingAddress['zipCode']);
    customerData.append('billingAddress[city]', data.billingAddress['city']);
    customerData.append('billingAddress[countryName]', data.billingAddress['countryName']);
    customerData.append('billingAddress[isoCountryCode]', data.billingAddress['isoCountryCode']);
    customerData.append('billingAddress[latitude]', data.billingAddress['latitude'] ? data.billingAddress['latitude'] : '');
    customerData.append('billingAddress[longitude]', data.billingAddress['longitude'] ? data.billingAddress['longitude'] : '');
    customerData.append('billingAddress[isBilling]', 1);
    customerData.append('billingAddress[isShipping]', data.billingAddressIsShippingAddress ? 1 : 0);
    customerData.append('billingAddress[customerAddressId]', data.billingAddress['customerAddressId']);
    customerData.append('billingAddress[inseeCode]', data.billingAddress['inseeCode'] ? data.billingAddress['inseeCode'] : $('#billingInseeCode').val());
    customerData.append('billingAddress[normalizationStatus]', data.billingAddress['normalizationStatus'] ? data.billingAddress['normalizationStatus'] : 0);
    customerData.append('hasTwoAddresses', data.billingAddressIsShippingAddress ? 0 : 1);
    if (data.shippingAddress) {
        customerData.append('shippingAddress[customerAddressId]', data.shippingAddress['customerAddressId']);
        customerData.append('shippingAddress[firstname]', data.shippingAddress['firstname']);
        customerData.append('shippingAddress[lastname]', data.shippingAddress['lastname']);
        customerData.append('shippingAddress[streetAddress]', data.shippingAddress['streetAddress'] ? data.shippingAddress['streetAddress'] : '');
        customerData.append('shippingAddress[streetAddressComplement]', data.shippingAddress['streetAddressComplement']);
        customerData.append('shippingAddress[countryName]', data.shippingAddress['countryName']);
        customerData.append('shippingAddress[isoCountryCode]', data.shippingAddress['isoCountryCode']);
        customerData.append('shippingAddress[zipCode]', data.shippingAddress['zipCode']);
        customerData.append('shippingAddress[city]', data.shippingAddress['city']);
        customerData.append('shippingAddress[latitude]', data.shippingAddress['latitude']);
        customerData.append('shippingAddress[longitude]', data.shippingAddress['longitude']);
        customerData.append('shippingAddress[civility]', data.shippingAddress['civility']);
        customerData.append('shippingAddress[inseeCode]', data.shippingAddress['inseeCode'] ? data.shippingAddress['inseeCode'] : $('#shippingInseeCode').val());
        customerData.append('shippingAddress[isBilling]', 0);
        customerData.append('shippingAddress[isShipping]', 1);
        customerData.append('shippingAddress[latitude]', data.shippingAddress['latitude'] ? data.shippingAddress['latitude'] : '');
        customerData.append('shippingAddress[longitude]', data.shippingAddress['longitude'] ? data.shippingAddress['longitude'] : '');
        customerData.append('shippingAddress[normalizationStatus]', data.shippingAddress['normalizationStatus']  ? data.shippingAddress['normalizationStatus'] : 0);
    }
    return customerData;
}
export const createCustomerMetaInfos = (tab) => {
    let codes = [];
    let items = [];
    let item = null;

    for (let key in tab) {
        codes.push(key);
        item = {'code': key, 'value': tab[key]}
        items.push(item);
    }
    return {'metaInfos': {'codes': codes, 'items': items}}
}
export const position = (obj) => {
    let currenttop = 0;
    if (obj.offsetParent) {
        do {
            currenttop += obj.offsetTop;
        } while ((obj = obj.offsetParent));
        return [currenttop];
    }
}

/**
 * validation des champs formulaire prendre rdv
 * @param params
 * @param onlyAppointmentChecked
 * @returns {null|jsonObject}
 */
export const isValidAppointmentDataRegistrationForm = (params, onlyAppointmentChecked) => {
    if (onlyAppointmentChecked) {
        if (params.appointments[0].date && params.appointments[0].scheduleId && params.appointments[0].scheduleId != '-1') {
            return params
        }
    } else {
        const appointmentsChecked = params.appointments;
        if (appointmentsChecked.length > 0) {
            for (let i = 0, l = appointmentsChecked.length; i < l; i++) {
                if (appointmentsChecked[i].scheduleId == '-1' || appointmentsChecked[i].scheduleId === '') {
                    return null
                }
            }
            return params;
        }
    }
    return null;
}
/**
 * Preparer les lignes des commandes du rdv unique
 * @param data
 * @param items
 * @param mainRecipient
 * @param context
 * @returns {jsonObject}
 */
export const prepareDataRegisterAppointment = (data, items, mainRecipient) => {
    const typeRdv = "rdv_depot";
    const appointmentData = {};
    appointmentData['shopId'] = data.shopId
    appointmentData['origine'] = data.origine
    appointmentData['appointments[0][scheduleId]'] = data.appointments[0].scheduleId
    appointmentData['appointments[0][wpCustomerId]'] = data.appointments[0].wpCustomerId
    appointmentData['appointments[0][customerId]'] = data.appointments[0].customerId
    appointmentData['appointments[0][nosCustomerId]'] = data.appointments[0].nosCustomerId
    appointmentData['appointments[0][mail]'] = mainRecipient.email
    appointmentData['appointments[0][phone]'] = mainRecipient.phone
    appointmentData['appointments[0][firstName]'] = data.appointments[0].firstName
    appointmentData['appointments[0][lastName]'] = data.appointments[0].lastName
    appointmentData['appointments[0][civility]'] = data.appointments[0].civility
    appointmentData['appointments[0][date]'] = data.appointments[0].date
    appointmentData['appointments[0][type]'] = typeRdv
    appointmentData['appointments[0][order][0][documentNo]'] = data.appointments[0].order[0].documentNo
    appointmentData['appointments[0][order][0][orderId]'] = data.appointments[0].order[0].orderId
    appointmentData['appointments[0][order][0][id]'] = data.appointments[0].order[0].id
    appointmentData['appointments[0][order][0][idCrypt]'] = data.appointments[0].order[0].idCrypt
    appointmentData['appointments[0][order][0][orderDate]'] = data.appointments[0].order[0].orderDate
    items.forEach((element, i) => {
        appointmentData['appointments[0][order][0][orderLines][' + i + '][id]'] = element.id
        appointmentData['appointments[0][order][0][orderLines][' + i + '][productId]'] = element.productId
        appointmentData['appointments[0][order][0][orderLines][' + i + '][ean13]'] = element.ean13
        appointmentData['appointments[0][order][0][orderLines][' + i + '][qtyAppointment]'] = element.qtyAppointment
        appointmentData['appointments[0][order][0][orderLines][' + i + '][packageId]'] = element.package['id']
    })
    return appointmentData;
}
export const formatDimension = (dimension) => {
    return new Intl.NumberFormat('fr-FR',).format(dimension)
}
/**
 * Preparer les lignes des commandes du rdv multiple
 * @param data
 * @param mainRecipient
 * @param context
 */
export const prepareDataRegisterAppointments = (data, mainRecipient) => {
    const appointmentData = {};
    const typeRdv = "rdv_depot";
    const appointmentsChecked = data.appointments.filter(appointment => appointment.date && appointment.scheduleId)
    let appointmentsObject = {};
    appointmentsChecked.forEach(element => {
        const key = element.date + '::' + element.scheduleId
        if (appointmentsObject[key]) {
            let orderLines = appointmentsObject[key].order[0].orderLines;
            orderLines.push(element.order[0].orderLines[0]);
            appointmentsObject[key].order[0].orderLines = orderLines
        } else {
            appointmentsObject[key] = element;
        }
    })
    const appointmentsArray = Object.values(appointmentsObject)
    appointmentData['shopId'] = data.shopId
    appointmentData['origine'] = data.origine
    appointmentsArray.forEach((appointment, i) => {
        appointmentData['appointments[' + i + '][scheduleId]'] = appointment.scheduleId
        appointmentData['appointments[' + i + '][wpCustomerId]'] = appointment.wpCustomerId
        appointmentData['appointments[' + i + '][customerId]'] = appointment.customerId
        appointmentData['appointments[' + i + '][nosCustomerId]'] = appointment.nosCustomerId
        appointmentData['appointments[' + i + '][mail]'] = mainRecipient.email
        appointmentData['appointments[' + i + '][phone]'] = mainRecipient.phone
        appointmentData['appointments[' + i + '][firstName]'] = appointment.firstName
        appointmentData['appointments[' + i + '][lastName]'] = appointment.lastName
        appointmentData['appointments[' + i + '][civility]'] = appointment.civility
        appointmentData['appointments[' + i + '][date]'] = appointment.date
        appointmentData['appointments[' + i + '][type]'] = typeRdv
        appointmentData['appointments[' + i + '][order][0][documentNo]'] = appointment.order[0].documentNo
        appointmentData['appointments[' + i + '][order][0][orderId]'] = appointment.order[0].orderId
        appointmentData['appointments[' + i + '][order][0][id]'] = appointment.order[0].id
        appointmentData['appointments[' + i + '][order][0][idCrypt]'] = appointment.order[0].idCrypt
        appointmentData['appointments[' + i + '][order][0][orderDate]'] = appointment.order[0].orderDate
        appointment.order[0].orderLines.forEach((line, j) => {
            appointmentData['appointments[' + i + '][order][0][orderLines][' + j + '][id]'] = line.id
            appointmentData['appointments[' + i + '][order][0][orderLines][' + j + '][productId]'] = line.productId
            appointmentData['appointments[' + i + '][order][0][orderLines][' + j + '][ean13]'] = line.ean13
            appointmentData['appointments[' + i + '][order][0][orderLines][' + j + '][qtyAppointment]'] = line.qtyAppointment
            appointmentData['appointments[' + i + '][order][0][orderLines][' + j + '][packageId]'] = line.package['id']
        })
    })
    return appointmentData;
}

export const validateEmail = (email) => {
    var regExp = /^(?:[a-z0-9!#$%&'*+\/=?^_'{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_'{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
    return regExp.test(email);
}

export const validatePhone = (phone) => {
    var phoneRegExp = /^(06|07|\+336|\+337)[0-9]{8}$/
    if (!phone.match(phoneRegExp)) {
        return false
    }
    return true;
}

/**
 * Formater une date dd/mm/yyyy
 * @param date
 * @returns {string}
 */
export const formatDate = (date) => {
    const d = new Date(date)
    return ("0" + d.getDate()).slice(-2) + "/" + ("0" + (d.getMonth() + 1)).slice(-2) + "/" + d.getFullYear()
}

export const removeSpecialCharAndAccents = (s, replaceFunction = '') => {
    let str = this.removeAccents(s);
    let regex = new RegExp(/([^A-Za-z0-9\-\_\.\ ])/);
    if (regex.test(str)) {
        return str.replace(/[^A-Za-z0-9\-\_\.\ ]/gi, replaceFunction)
    }
    return str;
};
export const replaceAll = (str, obj) => {
    for (const elt in obj) {
        str = str.replace(new RegExp(elt, 'g'), obj[elt]);
    }
    return str;
};
export const formatDateWithTime = (date) => {
    const year = date.getUTCFullYear();
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    const day = date.getUTCDate().toString().padStart(2, '0');
    const hour = date.getHours().toString().padStart(2, '0');
    const minute = date.getMinutes().toString().padStart(2, '0');
    const second = date.getSeconds().toString().padStart(2, '0');
    const millisecond = date.getMilliseconds().toString().padStart(3, '0');

    return `${year}-${month}-${day}T${hour}:${minute}:${second}.${millisecond}`;
}
